<template>
  <span>
    <v-icon small @click="abrirDialog()">mdi-pencil</v-icon>

    <SysDialog
      v-model="dialog"
      titulo="Cobertura do estoque de segurança"
      largura="460"
      @click:primary="salvarEsseg()"
      @click:hidden-dialog="fecharDialog()"
    >
      <TextFieldFormatadorDeValor
        v-model="valor_estoque_de_seguranca"
        outlined
        :maxDigitos="3"
        suffix="dias"
        @focus="$event.target.select()"
        @keyup.enter="salvarEsseg()"
      />
    </SysDialog>
  </span>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import { atualizarEstoqueSeguranca } from "./ApiEstoqueSeguranca";

export default {
  props: {
    detalhes_produto: {
      type: Object,
      required: true
    }
  },
  components: {
    SysDialog,
    TextFieldFormatadorDeValor
  },
  data: () => ({
    dialog: false,
    valor_estoque_de_seguranca: 0
  }),
  methods: {
    abrirDialog() {
      this.valor_estoque_de_seguranca = this.detalhes_produto.cobertura_estoque_seguranca;
      this.dialog = true;
    },
    fecharDialog() {
      this.dialog = false;
    },
    salvarEsseg() {
      const params = {
        id_grupo: this.$store.getters['usuario/getGrupoCompras'],
        id_fornecedor: this.detalhes_produto.idfornecedor,
        idproduto: this.detalhes_produto.idproduto,
        estoque_seguranca: this.valor_estoque_de_seguranca,
        produto_eh_combinacao: this.detalhes_produto.produto_eh_combinacao
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        atualizarEstoqueSeguranca(params)
          .then(() => {
            this.fecharDialog();
            this.$emit("atualizar-cobertura", this.valor_estoque_de_seguranca);
          })
          .catch(() => this.Helpers.logout())
      );
    }
  }
}
</script>

<style>

</style>
